import { render, staticRenderFns } from "./Winners.vue?vue&type=template&id=15d91aa8&"
import script from "./Winners.vue?vue&type=script&lang=ts&"
export * from "./Winners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports